import React, { useState, useEffect } from 'react';
import { LineChart } from '@mui/x-charts/LineChart';
import './patient.css';
import api from '../../service/caller'; // Axios instance configurée
import { getUserIdFromToken } from '../../utils/authUtils';
import {  toast } from 'react-toastify';
import { Button } from '@mui/material';


const PatientTrends = () => {
  const [hospitals, setHospitals] = useState([]);
  const [message, setMessage] = useState('');
  const [selectedHospital, setSelectedHospital] = useState();
  const [selectedDepartment, setSelectedDepartment] = useState('');
  const [loading, setLoading] = useState(false);
    const [isLoading, setIsLoading] = useState(true);
    const [selectedYear1, setSelectedYear1] = useState(new Date().getFullYear());
    const [comparisonYear, setComparisonYear] = useState(new Date().getFullYear() - 1);
    const [comparisonData, setComparisonData] = useState([]);
    const [showComparison, setShowComparison] = useState(false);
    const [patientTrends, setPatientTrends] = useState([]);
    
    useEffect(() => {
        const fetchPatientTrends = async () => {
          try {
            setIsLoading(true);
            const params = new URLSearchParams();
            params.append('year', selectedYear1);
            if (selectedHospital) params.append('hospitalId', selectedHospital);
            if (selectedDepartment) params.append('departmentId', selectedDepartment);
            
            const response = await api.get(`api/patient-trends?${params.toString()}`);
            // Add year indicator to each data point
            const dataWithYear = response.data.map(item => ({
              ...item,
              year: selectedYear1,
              label: `${item.month} ${selectedYear1}`
            }));
            setPatientTrends(dataWithYear);
          } catch (error) {
            toast.error("Failed to fetch patient trends");
            console.error(error);
          } finally {
            setIsLoading(false);
          }
        };
        fetchPatientTrends();
      }, [selectedHospital, selectedYear1, comparisonYear, selectedDepartment]);

    const fetchComparisonData = async () => {
        try {
          setIsLoading(true);
          const params = new URLSearchParams();
          params.append('year', comparisonYear);
          if (selectedHospital) params.append('hospitalId', selectedHospital);
          if (selectedDepartment) params.append('departmentId', selectedDepartment);
          
          const response = await api.get(`api/patient-trends?${params.toString()}`);
          // Add year indicator to each data point
          const dataWithYear = response.data.map(item => ({
            ...item,
            year: comparisonYear,
            label: `${item.month} ${comparisonYear}`
          }));
          setComparisonData(dataWithYear);
        } catch (error) {
          toast.error("Failed to fetch comparison data");
          console.error(error);
        } finally {
          setIsLoading(false);
        }
      };
    
      // Call comparison data fetch when comparison year changes
      useEffect(() => {
        if (showComparison) {
          fetchComparisonData();
        }
      }, [comparisonYear, selectedHospital, selectedYear1, selectedDepartment]);

    const toggleComparison = () => {
      setShowComparison((prev) => !prev);
      if (!showComparison) {
        fetchComparisonData();
      }
    };

    const currentYearData = showComparison ? 
    patientTrends.filter(item => item?.year == selectedYear1) : 
    patientTrends;
    
  const comparisonYearData = showComparison ?
    comparisonData.filter(item => item?.year == comparisonYear) : 
    [];

  const userId = getUserIdFromToken();

  // Charger les hôpitaux
  useEffect(() => {
    const fetchHospitals = async () => {
      if (!userId) {
        setMessage('Utilisateur non authentifié.');
        return;
      }
      try {
        setLoading(true);
        const token = localStorage.getItem('access_token');
        const response = await api.get(`/api/hospitals/admin/` + token, {
          headers: {
            'Authorization': `Bearer ${localStorage.getItem('access_token')}`
          }
        });
        setHospitals(response.data);
        setLoading(false);
      } catch (error) {
        console.error('Erreur lors de la récupération des hôpitaux:', error);
        setMessage('Erreur lors de la récupération des hôpitaux.');
        setLoading(false);
      }
    };
    if (userId) {
      fetchHospitals();
    }
  }, [userId]);

  return (
    <div className="patient-trends-container">
<div className='sec-container'>
          <div className='cont-header'>
            <span>Patient trends</span>
          </div>
          <div className='les-filtres'>
            <select 
              className="stat-select"
              value={selectedHospital}
              onChange={(e) => setSelectedHospital(e.target.value)}
            >
              <option value="">All Hospitals</option>
              {hospitals.map((hospital, index) => (
                <option key={index} value={hospital._id}>
                  {hospital.hospital_name}
                </option>
              ))}
            </select>

            <div className='filtres2'>
            <select 
              className="stat-select"
              value={selectedYear1}
              onChange={(e) => setSelectedYear1(e.target.value)}
            >
              {Array.from({ length: 10 }, (_, i) => {
                const year = new Date().getFullYear() - i;
                return <option key={year} value={year}>{year}</option>;
              })}
            </select>


              {showComparison && (
                <select 
                  className="stat-select"
                  value={comparisonYear}
                  onChange={(e) => setComparisonYear(e.target.value)}
                >
                  {Array.from({ length: 10 }, (_, i) => {
                    const year = new Date().getFullYear() - i;
                    return <option key={year} value={year}>{year}</option>;
                  })}
                </select>
              )}

              <Button
                variant="contained"
                onClick={toggleComparison}
                sx={{ backgroundColor: showComparison ? "#f44336" : "#1976d2" }}
              >
                {showComparison ? "Hide Comparison" : "Compare Years"}
              </Button>
            </div>
          </div>

          
         {(!showComparison) ? (
            <LineChart
              className='barch'
              dataset={patientTrends}
              xAxis={[
                {
                  dataKey: "month",
                  scaleType: "band",
                  tickLabelStyle: { fontSize: 12, fontWeight: 500, fill: "#666" },
                },
              ]}
              series={[{ dataKey: "y", color: "#007bff", showMark: true }]}
              height={300}
              margin={{ left: 30, right: 30, top: 30, bottom: 30 }}
              grid={{ vertical: false, horizontal: true }}
            />
          ) : (
            <LineChart
              className='barch'
              xAxis={[
                {
                  dataKey: "month", 
                  scaleType: "band",
                  data: currentYearData.length > 0 
                    ? currentYearData.map(item => item?.month)
                    : ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
                  tickLabelStyle: { fontSize: 12, fontWeight: 500, fill: "#666" },
                },
              ]}
              series={[
                { 
                  data: currentYearData.map(item => item?.y || 0),
                  label: `${selectedYear1}`,
                  color: "#007bff", 
                  showMark: true,
                },
                { 
                  data: comparisonYearData.map(item => item?.y || 0),
                  label: `${comparisonYear}`,
                  color: "#ff4757", 
                  showMark: true,
                }
              ]}
              height={300}
              margin={{ left: 30, right: 30, top: 30, bottom: 30 }}
              grid={{ vertical: false, horizontal: true }}
              slotProps={{
                legend: {
                  direction: 'row',
                  position: { vertical: 'top', horizontal: 'middle' },
                  padding: 20,
                },
              }}
            />
          )}
          
          {showComparison && (
            <div className="comparison-legend" style={{ textAlign: 'center', marginTop: '10px' }}>
              <div style={{ display: 'inline-block', marginRight: '20px' }}>
                <span style={{ display: 'inline-block', width: '15px', height: '15px', backgroundColor: '#007bff', marginRight: '5px' }}></span>
                <span>{selectedYear1}</span>
              </div>
              <div style={{ display: 'inline-block' }}>
                <span style={{ display: 'inline-block', width: '15px', height: '15px', backgroundColor: '#ff4757', marginRight: '5px' }}></span>
                <span>{comparisonYear}</span>
              </div>
            </div>
          )}
        </div>

      {/* <div className="patient-trends-analysis">
        <div className="patient-trends-analysis-title">Analyse Automatique</div>
      </div>

      <div className="patient-trends-actions">
        <button className="patient-trends-btn patient-trends-btn-pdf" onClick={() => exportPDF()}>PDF</button>
        <button className="patient-trends-btn patient-trends-btn-excel" onClick={() => exportExcel()}>Excel</button>
      </div> */}
    </div>
  );
};

// Fonctions d'export (à implémenter)
const exportPDF = () => {
  console.log('Export PDF à implémenter');
  // Implémentation à faire
};

const exportExcel = () => {
  console.log('Export Excel à implémenter');
  // Implémentation à faire
};

export default PatientTrends;